// GA4 + Meta Pixel — activate only when IDs are present in env.
const GA_ID = process.env.REACT_APP_GA4_ID;
const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

let initialized = false;

export const initAnalytics = () => {
  if (initialized) return;
  initialized = true;

  if (GA_ID) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", GA_ID, { send_page_view: false });
  }

  if (PIXEL_ID && !window.fbq) {
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0";
      n.queue = []; t = b.createElement(e); t.async = !0; t.src = v;
      s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
    window.fbq("init", PIXEL_ID);
  }
};

export const trackPageView = (path) => {
  if (GA_ID && window.gtag) {
    window.gtag("event", "page_view", { page_path: path, page_location: window.location.href });
  }
  if (PIXEL_ID && window.fbq) window.fbq("track", "PageView");
};

export const trackEvent = (name, params = {}) => {
  if (GA_ID && window.gtag) window.gtag("event", name, params);
};

// Lead fired only after genuine successful signup; eventID enables CAPI dedup later.
export const trackLead = () => {
  const eventID = (window.crypto?.randomUUID && window.crypto.randomUUID()) || `${Date.now()}`;
  if (GA_ID && window.gtag) window.gtag("event", "email_signup", { method: "enter_the_society" });
  if (PIXEL_ID && window.fbq) {
    window.fbq("track", "Lead", { content_name: "Enter the Society", currency: "NZD" }, { eventID });
  }
  return eventID;
};
